/* eslint-disable no-case-declarations */
import * as commonTypes from './actionTypes';

export const initialState = {
  errorMessage: '',
  isLoading: false,
  isSkeleton: true,
  showBanners: true,
  router: {
    isAllowed: true,
    redirectTo: '',
  },
  snackBar: {
    showSnackBar: false,
    title: '',
    type: 'error',
    //    icon: '',
    //    imgSrc: '',
  },
  hasError: {},
  snackBarResult: '',
  modal: {
    title: '',
    showModal: false,
    paragraph: '',
    subtitle: '',
    imgSrc: '',
    firstButtonClass: '',
    firstButtonText: '',
    respOnClickFirst: '',
    showSecondButton: false,
    secondButtonClass: '',
    secondButtonText: '',
    respOnClickSecond: '',
  },
  modalResult: '',
  legalText: '',
  helpUrl: null,
  helpLink: null,
  docTypes: null,
  banksCodes: null,
  npsWidget: null,
  contactUs: null,
  contactEmail: null,
  formValidationErrors: {
    hasError: false,
    fields: [],
  },
  timersSentEmail: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case commonTypes.SHOW_ERR_MSG:
      const snackBar = action.payload;
      if (snackBar.snackBarType) {
        snackBar.type = snackBar.snackBarType;
      }
      snackBar.showSnackBar = true;
      // timer = 3000,
      return {
        ...state,
        errorMessage: action.payload,
        snackBar,
      };

    case commonTypes.SHOW_ON_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case commonTypes.HIDE_ON_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    case commonTypes.SHOW_ON_SKELETON:
      return {
        ...state,
        isSkeleton: true,
      };

    case commonTypes.HIDE_ON_SKELETON:
      return {
        ...state,
        isSkeleton: false,
      };

    case commonTypes.SET_ROUTER:
      const router = action.payload;
      return {
        ...state,
        router,
      };

    case commonTypes.SET_MODAL_DATA_AND_SHOW:
      const modal = action.payload;
      modal.showModal = true;
      return {
        ...state,
        modal,
      };

    case commonTypes.SET_MODAL_RESULT:
      const modalResult = action.payload;
      return {
        ...state,
        modalResult,
      };

    case commonTypes.HIDE_MODAL:
      return {
        ...state,
        modal: initialState.modal,
      };

    case commonTypes.SET_SNACKBAR_DATA_AND_SHOW:
      const snackBar2 = action.payload;
      snackBar2.showSnackBar = true;
      return {
        ...state,
        snackBar2,
      };

    case commonTypes.SET_SNACKBAR_RESULT:
      return {
        ...state,
        snackBarResult: action.payload,
      };

    case commonTypes.HIDE_SNACKBAR:
      return {
        ...state,
        snackBar: initialState.snackBar,
      };

    case commonTypes.SET_LEGAL_TEXT:
      return {
        ...state,
        legalText: action.payload,
      };

    case commonTypes.SET_DOCUMENTS_TYPES:
      const docTypes = { ...action.payload };
      return {
        ...state,
        docTypes,
      };

    case commonTypes.SET_BANK_CODES:
      const banksCodes = { ...action.payload };
      return {
        ...state,
        banksCodes,
      };

    case commonTypes.SET_NPS_WIDGET:
      return {
        ...state,
        npsWidget: action.payload,
      };

    case commonTypes.SET_MODAL:
      return {
        ...state,
        modal: action.payload,
      };

    case commonTypes.SET_CONTACT_EMAIL:
      return {
        ...state,
        contactEmail: action.payload,
      };

    case commonTypes.SET_FORM_VALIDATION_ERRORS:
      return {
        ...state,
        formValidationErrors: action.payload,
      };

    case commonTypes.SET_TIMER_SENT_EMAIL: {
      return {
        ...state,
        timersSentEmail: action.payload,
      };
    }
    case commonTypes.SHOW_BANNERS:
      return {
        ...state,
        showBanners: true,
      };

    case commonTypes.HIDE_BANNERS:
      return {
        ...state,
        showBanners: false,
      };

    default:
      return {
        ...state,
      };
  }
};
